<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay">
        <Transition name="modal-scale">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title">
                <img :src="usdtIcon" alt="USDT" class="title-icon" />
                {{ $t("message.select_network") }}
              </div>
              <div class="close-btn" @click="handleClose">×</div>
            </div>

            <div class="network-options">
              <div v-for="(option, index) in networkOptions" :key="index" :class="[
                'network-option',
                selectedNetwork === option.id ? 'selected' : '',
              ]" @click="selectNetwork(option.id)">
                <div class="network-icon">
                  <img :src="option.icon" :alt="option.name" />
                </div>
                <div class="network-name">{{ option.name }}</div>
                <div class="network-check">
                  <div class="check-circle" :class="{ active: selectedNetwork === option.id }"></div>
                </div>
              </div>
            </div>

            <div class="network-footer">
              <button class="confirm-btn" @click="handleConfirm" :disabled="isLoading">
                {{ $t("message.Confirm") }}
              </button>
            </div>

            <!-- 状态提示 -->
            <Transition name="fade">
              <div v-if="status" class="status-overlay">
                <div class="status-content">
                  <div v-if="isLoading" class="loading-spinner"></div>
                  <span>{{ status }}</span>
                </div>
              </div>
            </Transition>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import emitter from "@/utils/bus";
import { appHapticFeedback, appHapticFeedbackSoft } from "@/utils/common";
import { useI18n } from "vue-i18n";
import { useConfigStore } from "@/store/config";
import tron from "@/assets/networks/tron.svg";
import ton from "@/assets/networks/ton.svg";
import usdtIcon from "@/assets/payment-icon/usdt.svg";

const { t } = useI18n();
const config = useConfigStore();

const themeColor = computed(() => {
  return config.themes_color;
});

const visible = ref(false); // 是否显示
const selectedNetwork = ref("tron"); // 选中的网络
const isLoading = ref(false); // 加载状态
const status = ref(""); // 状态提示
const funUSDT = ref(null); // 网络选项
const amount = ref(0); // 金额
const params = ref(null); // 参数
// 网络选项
const networkOptions = [
  {
    id: "tron",
    name: "TRON Chain - TRC20",
    icon: tron,
  },
  {
    id: "ton",
    name: "TON Chain",
    icon: ton,
  }
];

const selectNetwork = (id) => {
  appHapticFeedbackSoft();
  selectedNetwork.value = id;
};

const handleConfirm = async () => {
  appHapticFeedback();
  isLoading.value = true;
  status.value = t("message.creating_order");

  try {
    // 这里添加切换网络的逻辑
    let usdtRes;
    console.log(funUSDT.value, params.value);
    let reqParams = {
      ...params.value,
      chain_type: selectedNetwork.value,
    };
    usdtRes = await funUSDT.value(reqParams);
    if (usdtRes.code === 200) {
      emitter.emit("showOtherTonPayment", {
        data: usdtRes,
        amount: amount.value,
        params: reqParams,
        selectedNetwork: selectedNetwork.value,
        isMode: false,
      });
      isLoading.value = false;
      status.value = "";
        handleClose();
      } else {
      status.value = t("message.create_order_failed");
      setTimeout(() => {
        status.value = "";
        isLoading.value = false;
        handleClose();
      }, 2000);
    }

  } catch (error) {
    console.error(error);
    status.value = t("message.error");
    setTimeout(() => {
      status.value = "";
    }, 2000);
  } finally {
    isLoading.value = false;
  }
};

const handleClose = () => {
  visible.value = false;
};

const showNetworkModal = (payAmount) => {
  funUSDT.value = payAmount.funUSDT;
  amount.value = payAmount.amount;
  params.value = payAmount.params;
  visible.value = true;
};

onMounted(() => {
  emitter.on("showNetworkModal", showNetworkModal);
  emitter.on("closeNetworkModal", () => {
    visible.value = false;
  });
});

watch(
  () => themeColor.value,
  (newVal) => {
    document.documentElement.style.setProperty("--theme-color", newVal);
  }
);

onUnmounted(() => {
  emitter.off("showNetworkModal", showNetworkModal);
  emitter.off("closeNetworkModal", showNetworkModal);
});
</script>

<style scoped>
:root {
  --theme-color: #00ff9d;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: Arial, sans-serif;
}

.modal-content {
  background-color: #ffffff;
  border-radius: 4vw;
  width: 92vw;
  max-width: 600px;
  max-height: 80vh;
  position: relative;
  box-shadow: 0 0.6vw 3vw rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 4vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.3vw solid #e5e5e5;
}

.modal-title {
  font-size: 5.5vw;
  color: #333333;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 2vw;
}

.title-icon {
  width: 6vw;
  height: 6vw;
  object-fit: contain;
}

.close-btn {
  font-size: 7vw;
  color: #999999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  color: #333333;
}

.network-options {
  padding: 4vw;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.network-options::-webkit-scrollbar {
  display: none;
}

.network-option {
  display: flex;
  align-items: center;
  padding: 4vw;
  background-color: #f5f5f5;
  border-radius: 3vw;
  margin-bottom: 3vw;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 0.4vw solid transparent;
}

.network-option:last-child {
  margin-bottom: 0;
}

.network-option.selected {
  border-color: var(--theme-color);
  background-color: #ffffff;
  box-shadow: 0 0 2vw rgba(0, 255, 157, 0.2);
}

.network-icon {
  width: 10vw;
  height: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4vw;
}

.network-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.network-name {
  flex: 1;
  font-size: 4vw;
  color: #333333;
}

.check-circle {
  width: 5vw;
  height: 5vw;
  border-radius: 50%;
  border: 0.5vw solid #cccccc;
  position: relative;
  transition: all 0.3s ease;
}

.check-circle.active {
  border-color: var(--theme-color);
  background-color: var(--theme-color);
  box-shadow: 0 0 1vw rgba(0, 255, 157, 0.4);
}

.check-circle.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2vw;
  height: 2vw;
  background-color: #000000;
  border-radius: 50%;
}

.network-footer {
  padding: 3vw;
  background-color: #f5f5f5;
  border-radius: 0 0 3vw 3vw;
}

.confirm-btn {
  width: 100%;
  background-color: var(--theme-color);
  border: none;
  color: #fff;
  font-size: 4.5vw;
  font-weight: bold;
  padding: 4vw;
  border-radius: 2vw;
  cursor: pointer;
  transition: all 0.3s ease;
}

.confirm-btn:hover {
  opacity: 0.9;
  transform: translateY(-0.2vw);
}

.confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3vw;
}

.status-content {
  text-align: center;
  color: #333333;
  font-size: 4vw;
}

.loading-spinner {
  width: 10vw;
  height: 10vw;
  border: 0.8vw solid #e5e5e5;
  border-top-color: var(--theme-color);
  border-radius: 50%;
  animation: spin 1s infinite linear;
  margin: 0 auto 3vw;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: all 0.3s ease;
}

.modal-scale-enter-from,
.modal-scale-leave-to {
  transform: scale(0.9);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>